import React, { useEffect, useState } from 'react';
import { FaBookOpen, FaGamepad, FaHome, FaQuestion, FaShoppingCart, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../auth/UseUser';
import { TypeOfEtity } from '../model/enum/typeOfEntity';
import { getKategorijeVisible } from '../server/server-kategorije-tree';
import ProfilModal from './login/ProfilModal';
import { PUSKICE_ENABLED } from '../constatnts/FeatureFlags';

function PhoneFooter({ setIsOpen }: any) {
    const [profilModalOpen, setProfilModalOpen] = useState(false);
    const {
        isSignedIn,
        user,
        setUser,
        setIsAdminApp,
        setTipEtiteta,
        setShowSelectedPuskica,
        setSelectedPuskica,
        setSelectedPitanja,
        setNavLista,
        setReturnedList,
    } = useUser();
    const navigate = useNavigate();
    const logout = () => {
        if (window.confirm('Da li ste sigurni da želite da se odjavite?')) {
            localStorage.clear();
            setUser({});
        }
    };
    // const handleAdminButton = () => {
    // 	navigate('/admin');
    // 	setIsAdminApp(true);
    // };
    const handleKvizoviButton = () => {
        navigate('/user/kviz');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setNavLista([]);
        setReturnedList([]);
        setIsAdminApp(false);
        setIsOpen(false);
    };
    const handleHomeButton = () => {
        navigate('/user/kategorija');
        setShowSelectedPuskica(false);
        setSelectedPuskica(null);
        setSelectedPitanja([]);
        setIsAdminApp(false);
    };
    const handlePuskiceButton = () => {
        navigate('/user/puskice');
        setShowSelectedPuskica(false);
        setNavLista([]);
        setReturnedList([]);
        setIsAdminApp(false);
        loadKategorijeVisible();
    };
    const handleTestoviButton = () => {
        navigate('/user/oblast/54ba3d07-da2b-44b9-a734-a8c835cae69b');
        setShowSelectedPuskica(false);
        setIsAdminApp(false);
    };
    const loadKategorijeVisible = async () => {
        const resp = await getKategorijeVisible();
        if (resp.status === 200) {
            setTipEtiteta(TypeOfEtity.Kategorija);
            console.log('returned list', resp.data);
            setReturnedList(resp.data);
        }
    };
    const openProfileModal = () => {
        setProfilModalOpen(true);
    };
    const closeProfileModal = () => {
        setProfilModalOpen(false);
    };
    useEffect(() => {
        return () => {
            closeProfileModal;
        };
    }, []);

    return (
        <div className={`footer flex flex-row justify-around items-center lg:hidden bg-gradient-to-br from-blueLight via-blueDark to-blueLight z-[3]`}>
            <button className="flex flex-col items-center justify-center" onClick={() => handleHomeButton()}>
                <FaHome size={24} color="#bdbdbd" />
                <p className="text-[12.8px] text-grey-400 left-4 font-normal ">Kategorije</p>
            </button>
            {isSignedIn && PUSKICE_ENABLED && (
                <button className="flex flex-col items-center justify-center" onClick={() => handlePuskiceButton()}>
                    <FaBookOpen size={24} color="#bdbdbd" />
                    <p className="text-[12.8px] text-grey-400 left-4 font-normal ">Puškice</p>
                </button>
            )}
            <button className="flex flex-col items-center justify-center" onClick={() => handleKvizoviButton()}>
                <FaGamepad size={24} color="#bdbdbd" />
                <p className="text-[12.8px] text-grey-400 left-4 font-normal ">Kvizovi</p>
            </button>
            <button className="flex flex-col items-center justify-center" onClick={() => handleTestoviButton()}>
                <FaQuestion size={24} color="#bdbdbd" />
                <p className="text-[12.8px] text-grey-400 left-4 font-normal ">Testovi</p>
            </button>
            <button className="flex flex-col items-center justify-center" onClick={() => openProfileModal()}>
                <FaUser size={24} color="#bdbdbd" />
                <p className="text-[12.8px] text-grey-400    left-4 font-normal ">Profil</p>
            </button>
            <ProfilModal modalIsOpen={profilModalOpen} closeModal={closeProfileModal} />
        </div>
    );
}

export default PhoneFooter;
